import { fromJS } from 'immutable';

import {
  SET_CUSTOMER,
  FETCH_CUSTOMERS,
  FETCH_CUSTOMERS_SUCCESS,
  FETCH_CUSTOMERS_FAILED,
  FETCH_CUSTOMER_SUCCESS,
  FETCH_CUSTOMER_FAILED,
  SET_LOGO,
  ADD_CONTACT,
  REMOVE_CONTACT,
  ADD_ADDRESS,
  REMOVE_ADDRESS,
  ADD_TAG,
  REMOVE_TAG,
} from '../actions/customers';

import {
  updateOrAddMap,
  removeMap,
  updateOrAdd,
  remove,
} from './helper';

import { saveCustomerRoutine, removeCustomerRoutine } from '../routines';

const initialState = fromJS({
  customers: [],
  customer: {},
  loading: false,
});

export default function (state = initialState, action) {
  // console.log('action', action);
  switch (action.type) {
    case SET_CUSTOMER:
      return state.set('customer', fromJS(action.customer));
    case FETCH_CUSTOMERS:
      return state.set('loading', true);
    case FETCH_CUSTOMERS_SUCCESS:
      return state.set('loading', false)
        .set('customers', fromJS(action.customers));
    case FETCH_CUSTOMERS_FAILED:
      return state.set('loading', false)
        .set('error', fromJS(action.error));
    case FETCH_CUSTOMER_SUCCESS:
      return state.set('loading', false)
        .set('customer', fromJS(action.customer));
    case FETCH_CUSTOMER_FAILED:
      return state.set('loading', false)
        .set('error', fromJS(action.error));
    case SET_LOGO:
      console.log('SET_LOGOredu', action.logo);
      return state.setIn(['customer', 'logo'], action.logo);
    case ADD_CONTACT:
      console.log('cust', state.get('customer').toJS());
      return state.updateIn(['customer', 'contacts'], updateOrAddMap(fromJS(action.contact)))
        .updateIn(['customer', 'primaryContactId'], (primaryContactId) => {
          if (!primaryContactId) {
            return action.contact.id;
          }
          return primaryContactId;
        });
    case REMOVE_CONTACT:
      return state.set('loading', false)
        .updateIn(['customer', 'contacts'], removeMap(fromJS(action.contact)));
    case ADD_ADDRESS:
      return state.set('loading', false)
        .updateIn(['customer', 'addresses'], updateOrAddMap(fromJS(action.address)));
    case REMOVE_ADDRESS:
      return state.set('loading', false)
        .updateIn(['customer', 'addresses'], removeMap(fromJS(action.address)));
    case ADD_TAG:
      return state.updateIn(['customer', 'tags'], updateOrAdd(action.tag, (obj) => obj));
    case REMOVE_TAG:
      return state.set('loading', false)
        .updateIn(['customer', 'tags'], remove(action.tag, (obj) => obj));
    case saveCustomerRoutine.TRIGGER:
      return state;
    case saveCustomerRoutine.SUCCESS:
      console.log('fromJS(action.payload.customer)', action.payload.customer);
      return state
        .set('customer', fromJS(action.payload.customer))
        .set('saving', false)
        .updateIn(['customers'], updateOrAdd(fromJS(action.payload.customer)));
    case saveCustomerRoutine.FAILURE:
      console.log('action.error', action.error);
      return state.set('error', action.error).set('saving', false);
    case saveCustomerRoutine.FULFILL:
      return state;
    case removeCustomerRoutine.SUCCESS:
      return state.updateIn(['customers'], remove(fromJS(action.payload.customer)));
    case removeCustomerRoutine.FAILURE:
      return state.set('error', action.error);
    default :
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/customers.js